// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1dO6R","title":"ClientReferral_title__1hpdi","itemText":"ClientReferral_itemText__IRd-X"};